import axios from 'axios';
import { useCallback, useEffect, useState } from 'react'
import {node_marketing_should_show } from '../../../assets/jss/incept-sustainability-variables';


const useMarketingHandler = () => {
  const [showMarketing, setShowMarketing] = useState(false);
  const token = localStorage.getItem('token');
  const authStr = 'Bearer ' + token;

  const fetchShouldShowMarketing = useCallback(async () => {
    try {
      const response = await axios.get(`${node_marketing_should_show}?targetRole=universe-manager`, {
      headers: {
        Authorization: authStr
      }
      });
      setShowMarketing(response.data);
    } catch (error) {
      setShowMarketing(false);
    }
   }, []);

   useEffect(() => {
    if (!token) return;
    fetchShouldShowMarketing();
   }, [fetchShouldShowMarketing, token]);

   return {showMarketing};
}

export default useMarketingHandler;